class SectionHead extends React.Component {

    render() {
        return (
            <div className='row section__head'>

                <h1 className={this.props.className}>
                    {this.props.title}<span>.</span>
                </h1>

                <div className='section__h' />

                { this.props.subtitle &&
                    <p>
                        {this.props.subtitle}
                    </p>
                }
            </div>
        );
    }
}

export default SectionHead;



// WEBPACK FOOTER //
// ./ui_src/app/components/section/SectionHead.react.jsx